import React from "react";
import Navb from "../../components/navbar/Navb";
import Footer from "../../components/footer/Footer";
import "./sooji.css";
import ProductCard from "../../components/productCard/ProductCard";
import Img1 from "./img1.png";
import Img2 from "./img2.png";
import Img3 from "./img3.png";
import SingleRecipiePage from "../../components/singleRecipiePage/SingleRecipiePage";

const Sooji = () => {
  return (
    <>
      <Navb />
      <div className="soojimaintop">
        <div className="daliatoptext">
        "Nandi Sooji: Unleash Versatility in <br /> Every Granule, Elevating Every Dish."

        </div>
        <img
          src={Img2}
          alt="Img2"
          style={{ display: "block", padding: "8px 50px 0px" }}
        />
      </div>

      <div className="whiteComponentsingleEcavo bg4">
        <SingleRecipiePage
          currrentImg={Img3}
          heading="NANDI Sooji"
          text="Nandi’s Sooji stands as a testament to quality and tradition, offering a versatile ingredient that's a staple in kitchens worldwide. Made from premium-grade wheat, our Sooji boasts a fine texture and exceptional purity, ensuring perfect results in every dish. Whether you're whipping up fluffy halwa, delectable upma, or crispy dosas, Nandi Sooji promises culinary excellence with every serving. Elevate your cooking experience and savor the authentic taste of tradition with Nandi’s Sooji."
          link1="/recipes/soojidhokla"
          link1Text="View Recipes"
          link2="https://ecavo.shop/products/sooji"
          linkClass="whiteButton"
          //   sideImg={Sideimg1}
          headingcss="whiteHeading"
          pcss="whiteP"
        />
      </div>
      <div className="productCards">
        <ProductCard
          Heading="Versatility"
          Text="Nandi’s Sooji  is a versatile ingredient that can be used in a wide range of recipes. From classic desserts like halwa and ladoo to savory dishes like upma and dosa, its adaptability makes it a must-have in any kitchen. Enjoy the convenience and versatility of Nandi’s Sooji  as you explore new culinary creations."
        />
        <ProductCard
          Heading="Premium-Grade Wheat"
          Text="Made from the finest quality wheat grains, Nandi’s Sooji  upholds the highest standards of purity and quality. With meticulous sourcing and processing methods, it retains the natural goodness of wheat, delivering superior taste and nutrition to your meals."
        />
        <ProductCard
          Heading="Finely Ground Texture"
          Text="Nandi’s Sooji  boasts a finely ground texture, ensuring smooth and consistent results in every dish. Its fine texture allows for easy mixing and cooking, whether you're preparing traditional Indian sweets or savory delicacies."
        />
      </div>
      <Footer />
    </>
  );
};

export default Sooji;
